import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client.js';

interface AnalysisRunResult {
  lastAnalysisAt: string | null;
}

/**
 * Runs the analysis chain now, instead of waiting for the hourly pass.
 *
 * Unlike the demo data affordance this is not development-only: a team that has
 * just changed something on its portal must be able to see the effect without
 * waiting up to an hour, and without a terminal.
 */
export function useAnalysisRun(projectId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      api<AnalysisRunResult>(`/analytics/projects/${projectId}/analysis-runs`, { method: 'POST' }),
    // Every screen reads aggregates the run has just rewritten.
    onSuccess: () => queryClient.invalidateQueries(),
  });
}
